// extracted by mini-css-extract-plugin
export var alertCards = "_5-0";
export var card = "_5-1";
export var fade = "_5-2";
export var hidden = "_5-3";
export var progressBar = "_5-4";
export var roundtime = "_5-5";